"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _gradeSelector = _interopRequireDefault(require("./gradeSelector"));
var _topicSelector = _interopRequireDefault(require("./topicSelector"));
require("./styles.scss");
var _AppMediaProvider = require("../../../baseStyles/AppMediaProvider");
var _filter = _interopRequireDefault(require("./filter.svg"));
var _filterHollowLight = _interopRequireDefault(require("./filter-hollow-light.svg"));
var _filterHollowDark = _interopRequireDefault(require("./filter-hollow-dark.svg"));
var _cross = _interopRequireDefault(require("./cross.svg"));
var _state = require("printableWorksheets/state");
var _subjectSelector = _interopRequireDefault(require("./subjectSelector"));
var _printableWorksheets = require("printableWorksheets");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var WorksheetsNav = function WorksheetsNav() {
  var _activeBreadcrumb;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    isMobile = _useAppMediaProvider.isMobile;
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    activeGrade = _usePrintableWorkshee.activeGrade,
    activeBreadcrumb = _usePrintableWorkshee.activeBreadcrumb,
    subjectCode = _usePrintableWorkshee.subjectCode,
    showHeader = _usePrintableWorkshee.showHeader,
    setShowHeader = _usePrintableWorkshee.setShowHeader,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMobile ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheet-mobile-options"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "searchIconPortal"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      var elem = document.getElementById('ws-header');
      if (elem) {
        elem.scrollIntoView();
      }
      setShowHeader(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_filter["default"], null))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheets-nav ".concat(showHeader ? 'show-on-mobile' : '')
  }, isMobile ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheet-mobile-header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-header-left"
  }, worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? /*#__PURE__*/_react["default"].createElement(_filterHollowDark["default"], null) : /*#__PURE__*/_react["default"].createElement(_filterHollowLight["default"], null), "Filter"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-header-center"
  }, activeGrade, " ", /*#__PURE__*/_react["default"].createElement("div", {
    className: "circle"
  }), " ", subjectCode, " ", /*#__PURE__*/_react["default"].createElement("div", {
    className: "circle"
  }), " ", activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb = activeBreadcrumb[(activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : activeBreadcrumb.length) - 1]) === null || _activeBreadcrumb === void 0 ? void 0 : _activeBreadcrumb.title), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      setShowHeader(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))) : null, worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheets-nav__grade-selector"
  }, /*#__PURE__*/_react["default"].createElement(_gradeSelector["default"], null)), isMobile && worksheetsEnvironment !== _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheets-nav__subject-selector"
  }, /*#__PURE__*/_react["default"].createElement(_subjectSelector["default"], null)) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "worksheets-nav__topic-selector"
  }, /*#__PURE__*/_react["default"].createElement(_topicSelector["default"], {
    "data-sentry-element": "WorksheetTopicSelector",
    "data-sentry-source-file": "index.tsx"
  }))));
};
var _default = exports["default"] = WorksheetsNav;